<template>
<div class="kt-portlet__head">
    <slot></slot>
</div>
</template>

<script>
export default {

}
</script>